import { DeadheadSearchQuery, DeadheadSearch } from './findLoadsTypes';
import http from '../../utilities/httpUtils';

const ORDERS_SERVICE_URL = process.env.REACT_APP_ORDERS_SERVICE_URL;

export async function getLoads(
  query: DeadheadSearchQuery,
  useOrdersServiceDeadheadMigration: boolean
): Promise<DeadheadSearch[]> {
  const { data } = await (useOrdersServiceDeadheadMigration &&
    ORDERS_SERVICE_URL
    ? http.getWithURL<{ data: DeadheadSearch[] }, DeadheadSearchQuery>(
        `${ORDERS_SERVICE_URL}/orders/deadhead`
      )
    : http.get<{ data: DeadheadSearch[] }, DeadheadSearchQuery>(
        'orders/deadhead'
      ))(query);

  return data;
}

export async function getSimilarLoads(
  query: DeadheadSearchQuery,
  useOrdersServiceDeadheadMigration: boolean
): Promise<DeadheadSearch[]> {
  const { data } = await (useOrdersServiceDeadheadMigration &&
    ORDERS_SERVICE_URL
    ? http.getWithURL<{ data: DeadheadSearch[] }, DeadheadSearchQuery>(
        `${ORDERS_SERVICE_URL}/orders/deadhead/similar`
      )
    : http.get<{ data: DeadheadSearch[] }, DeadheadSearchQuery>(
        'orders/deadhead/similiar'
      ))(query);

  return data;
}

export async function getIsAvailable(
  id: string,
  useOrdersServiceDeadheadMigration: boolean
): Promise<{ isAvailable: boolean }> {
  const { data } = await (useOrdersServiceDeadheadMigration &&
    ORDERS_SERVICE_URL
    ? (id: string) =>
        http.getWithURL<{ data: { isAvailable: boolean } }>(
          `${ORDERS_SERVICE_URL}/orders/deadhead/${id}/isAvailable`
        )
    : (id: string) =>
        http.get<{ data: { isAvailable: boolean } }>(
          `orders/deadhead/${id}/isAvailable`
        ))(id)();

  return data;
}
